import { createSlice } from "@reduxjs/toolkit"

const documentsSlice = createSlice({
  name: 'documents',
  initialState: {
    documents: null,
    errors: []
  },
  reducers: {
    fullUpdate: (state, action) => {
      return { ...state, ...action.payload }
    },
    addDocument: (state, action) => {
      const document = action.payload
      state.documents = { ...state.documents, [document.id]: document }
    },
    updatedocuments: (state, action) => {
      state.documents = action.payload
    },
    updateErrors: (state, action) => {
      state.errors = action.payload
    }
  }
})

export const { addDocument, fullUpdate, updatedocuments, updateErrors } = documentsSlice.actions

export default documentsSlice.reducer